var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveDiamondIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.08295 8H17.9163M8.33295 3L6.66628 8L9.99961 17.5833L13.3329 8L11.6663 3M10.5118 17.3854L17.9773 8.42679C18.1038 8.27496 18.1671 8.19905 18.1912 8.1143C18.2126 8.03959 18.2126 7.96041 18.1912 7.88569C18.1671 7.80095 18.1038 7.72504 17.9773 7.57321L14.3662 3.23988C14.2927 3.1517 14.256 3.10762 14.2109 3.07592C14.171 3.04784 14.1265 3.02698 14.0794 3.01431C14.0262 3 13.9688 3 13.854 3H6.1452C6.03042 3 5.97303 3 5.91985 3.01431C5.87273 3.02698 5.82821 3.04784 5.7883 3.07592C5.74327 3.10762 5.70653 3.1517 5.63305 3.23988L2.02194 7.57321C1.89541 7.72504 1.83215 7.80095 1.80798 7.88569C1.78666 7.96041 1.78666 8.03959 1.80798 8.1143C1.83215 8.19904 1.89541 8.27496 2.02194 8.42679L9.48747 17.3854C9.66335 17.5965 9.75129 17.702 9.85657 17.7405C9.94894 17.7743 10.0503 17.7743 10.1427 17.7405C10.2479 17.702 10.3359 17.5965 10.5118 17.3854Z",
    stroke: "#7F56D9",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDiamondIcon);
export default __webpack_public_path__ + "static/media/ActiveDiamondIcon.ff27b982e41b1d9ab5a58618ab26c50e.svg";
export { ForwardRef as ReactComponent };